import { Form } from '@homex/se-react-components';
import styled from 'styled-components/macro';

import { large } from 'styles/breakpoints';
import { container, containerTall } from 'styles/layout';
import { description } from 'styles/typography';

export const FormGroup = styled(Form)`
  ${containerTall}
`;

export const Container = styled.div`
  ${container}

  margin-top: 24px;
  padding: 0 15px;
  text-align: left;
`;

export const ErrorContainer = styled(Container)`
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: center;
`;

export const Description = styled.p`
  ${description};

  margin: 0 0 17px;
  text-align: center;
`;

export const ErrorDescription = styled(Description)`
  margin-top: 6px;
`;

export const ErrorSubcontractor = styled(Description)`
  color: ${({ theme }) => theme.bottomForegroundDanger};
`;

export const Buttons = styled.div`
  ${container}

  margin-top: 61px;

  ${large`
    margin-top: 13px;
  `}
`;
